import axiosConfig from "../../Service/axiosConfig";

const base = "/salescrm";

export const salesCrmApi = {
  me: () => axiosConfig.get(`${base}/me/`),
  dashboard: (params) => axiosConfig.get(`${base}/dashboard/`, { params }),
  getTodaysLeads: (data = {}) => axiosConfig.post(`${base}/leads/today/`, data),
  listOpportunities: (params) =>
    axiosConfig.get(`${base}/opportunities/`, { params }),
  getOpportunity: (id) => axiosConfig.get(`${base}/opportunities/${id}/`),
  updateStatus: (id, data) =>
    axiosConfig.post(`${base}/opportunities/${id}/status/`, data),
  addNote: (id, notes) =>
    axiosConfig.post(`${base}/opportunities/${id}/note/`, { notes }),
  logCall: (id, data) =>
    axiosConfig.post(`${base}/opportunities/${id}/call/`, data),
  logWhatsapp: (id, details) =>
    axiosConfig.post(`${base}/opportunities/${id}/whatsapp/`, { details }),
  scheduleFollowUp: (id, data) =>
    axiosConfig.post(`${base}/opportunities/${id}/follow-up/`, data),
  completeFollowUp: (id, outcome) =>
    axiosConfig.post(`${base}/follow-ups/${id}/complete/`, { outcome }),
  createManual: (data) => axiosConfig.post(`${base}/opportunities/manual/`, data),
  reassign: (id, data) =>
    axiosConfig.post(`${base}/opportunities/${id}/reassign/`, data),
  reopen: (id, data) =>
    axiosConfig.post(`${base}/opportunities/${id}/reopen/`, data),
  employees: (params) => axiosConfig.get(`${base}/employees/`, { params }),
  saveEmployee: (data) => axiosConfig.post(`${base}/employees/`, data),
  settings: () => axiosConfig.get(`${base}/settings/`),
  patchSettings: (data) => axiosConfig.patch(`${base}/settings/`, data),
  sources: () => axiosConfig.get(`${base}/sources/`),
  patchSource: (data) => axiosConfig.patch(`${base}/sources/`, data),
  performance: () => axiosConfig.get(`${base}/admin/performance/`),
};

export const STATUS_LABELS = {
  new: "New",
  in_progress: "In Progress",
  interested: "Interested",
  follow_up: "Follow-up Scheduled",
  future_requirement: "Future Requirement",
  not_interested: "Not Interested",
  unreachable: "Unreachable",
  bought: "Bought",
  disqualified: "Disqualified",
};

export const CALL_OUTCOMES = [
  { value: "connected", label: "Connected" },
  { value: "no_answer", label: "No answer" },
  { value: "busy", label: "Busy" },
  { value: "wrong_number", label: "Wrong number" },
  { value: "switched_off", label: "Switched off" },
  { value: "other", label: "Other" },
];

export function formatWhen(value) {
  if (!value) return "—";
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return "—";
  return d.toLocaleString("en-IN", {
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
}
